module.exports = __webpack_public_path__ + "static/media/083.9852346f.jpg";